import React from "react"

import PropTypes from "prop-types"
import {Loader} from "semantic-ui-react"

import {SEMANTIC_UI_SIZE} from "../../constants/semanticSizes"

import "./style.scss"

export const LOADER_VARIANTS = {DEFAULT: "default"}

const Spinner = ({
    active = true,
    inline = true,
    size = SEMANTIC_UI_SIZE.SMALL,
    variant = LOADER_VARIANTS.DEFAULT,
    ...props
}) => (
    <Loader active={active} className={`variant-${variant}`} inline={inline} size={size} {...props} />
)

Spinner.propTypes = {
    active: PropTypes.bool,
    inline: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(SEMANTIC_UI_SIZE)),
    variant: PropTypes.string,
}

export default Spinner
